import React from 'react';
import { PaddingContainer } from '@components';
import * as styles from './ServicesHeader.module.scss';
import classNames from 'classnames';

export const ServicesHeader: React.FC = () => {
	return (
		<PaddingContainer
			className={classNames(styles.paddingContainerServices, 'white-bg')}
		>
			<div className={classNames(styles.servicesHeaderContainer)}>
				<h1
					className={classNames(
						styles.header,
						'font-size-title pb-2 mb-3 mt-0'
					)}
				>
					Services
				</h1>
				<p className="font-size-md pr-2 pr-sm-4 pr-md-0">
					The foundations for successful development are already laid.
				</p>
			</div>
		</PaddingContainer>
	);
};
